import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import Header from './Header';
import Hero from '../pages/Hero';
import Services from '../pages/Services';
import Camps from '../pages/Camps';
import Foundation from '../pages/Foundation';
import Beneficiaries from '../pages/Beneficiaries';
import Footer from './Footer';
import Contact from '../pages/Contact';
import Records from '../pages/Records';
import MobileClinics from '../pages/MobileClinics';
import Gallery from '../pages/Gallery';

const Home = () => {
const location = useLocation();

useEffect(() => {
if (location.state?.scrollTo) {
const section = document.getElementById(location.state.scrollTo);


  if (section) {
    setTimeout(() => {
      section.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }, 300);
  }
}


}, [location]);

return ( <div className="scroll-container"> <Header />


  <section className="snap-section">
    <Hero />
  </section>

  <section className="snap-section">
    <MobileClinics />
  </section>

  <section id="services" className="snap-section">
    <Services />
  </section>

  <section className="snap-section">
    <Records />
  </section>

  <section id="camps" className="snap-section">
    <Camps />
  </section>

  <section id="about" className="snap-section">
    <Foundation />
  </section>

  <section className="snap-section">
    <Gallery />
  </section>

  <section className="snap-section">
    <Beneficiaries />
  </section>

  <section id="contact" className="snap-section">
    <Contact />
  </section>

  <Footer />
</div>

);
};

export default Home;
